<!-- this element is required to load table CSS. When angular material add better way to render static tables,
     feel free to drop it. Or just render details as a list. -->
<table mat-table style="display: none">
  <tr mat-header-row *matHeaderRowDef="[]"></tr>
  <tr mat-row *matRowDef="let row; columns: []"></tr>
</table>

<table class="mat-mdc-table">
  <tbody>
    <tr class="mat-mdc-row">
      <th class="mat-mdc-header-cell mdc-data-table__header-cell">Client Code</th>
      <td class="mat-mdc-cell mdc-data-table__cell">
        <a [routerLink]="['/app/client-accounts/view', product().ClientCode]"> {{ product().ClientCode }} </a>
      </td>
    </tr>

    <tr class="mat-mdc-row">
      <th class="mat-mdc-header-cell mdc-data-table__header-cell">Client Name</th>
      <td class="mat-mdc-cell mdc-data-table__cell">{{ client()?.ClientName }}</td>
    </tr>

    <tr class="mat-mdc-row">
      <th class="mat-mdc-header-cell mdc-data-table__header-cell">Product Number</th>
      <td class="mat-mdc-cell mdc-data-table__cell">{{ product().JobNumber }}</td>
    </tr>

    <tr class="mat-mdc-row">
      <th class="mat-mdc-header-cell mdc-data-table__header-cell">Title</th>
      <td class="mat-mdc-cell mdc-data-table__cell">{{ product().Title }}</td>
    </tr>

    <tr class="mat-mdc-row">
      <th class="mat-mdc-header-cell mdc-data-table__header-cell">Product Owner</th>
      <td class="mat-mdc-cell mdc-data-table__cell">{{ product().ProductOwner }}</td>
    </tr>

    <tr class="mat-mdc-row">
      <th class="mat-mdc-header-cell mdc-data-table__header-cell">Status</th>
      <td class="mat-mdc-cell mdc-data-table__cell">{{ product().Status }}</td>
    </tr>

    <tr class="mat-mdc-row">
      <th class="mat-mdc-header-cell mdc-data-table__header-cell">Jira Title</th>
      <td class="mat-mdc-cell mdc-data-table__cell">
        <a href="{{ jira.link(product().JiraTitle) }}" target="_blank">{{ product().JiraTitle }}</a>
      </td>
    </tr>

    <tr class="mat-mdc-row">
      <th class="mat-mdc-header-cell mdc-data-table__header-cell">Commissionable</th>
      <td class="mat-mdc-cell mdc-data-table__cell">{{ product().Commissionable ? 'Yes' : 'No' }}</td>
    </tr>

    <tr class="mat-mdc-row">
      <th class="mat-mdc-header-cell mdc-data-table__header-cell">Cost per story point</th>
      <td class="mat-mdc-cell mdc-data-table__cell">
        @if (completedSp()) {
          <div class="cell-actions">
            ${{ projectValue() / completedSp() | number: '.0-2' }} per SP
            <span class="spacer"></span>
            <mat-chip>${{ projectValue() | number }} / {{ completedSp() }}SP</mat-chip>
          </div>
        } @else {
          -
        }
      </td>
    </tr>

    <tr class="mat-mdc-row">
      <th class="mat-mdc-header-cell mdc-data-table__header-cell">Budget Note</th>
      <td class="mat-mdc-cell mdc-data-table__cell">{{ product().BudgetNote || '' }}</td>
    </tr>

    @if (product().Notes) {
      <tr class="mat-mdc-row">
        <th class="mat-mdc-header-cell mdc-data-table__header-cell">Notes</th>
        <td class="mat-mdc-cell mdc-data-table__cell">{{ product().Notes }}</td>
      </tr>
    }
    @if (client()?.XeroId) {
      <tr class="mat-mdc-row">
        <th class="mat-mdc-header-cell mdc-data-table__header-cell">Client Xero ID</th>
        <td class="mat-mdc-cell mdc-data-table__cell">
          <a
            target="_blank"
            href="https://go.xero.com/Contacts/View.aspx?contactID={{ client()?.XeroId }}"
            title="{{ client()?.XeroId }}"
          >
            {{ client()?.XeroId }}
          </a>
        </td>
      </tr>
    }
    @if (agreements().length) {
      <tr class="mat-mdc-row">
        <th class="mat-mdc-header-cell mdc-data-table__header-cell">Agreements</th>
        <td class="mat-mdc-cell mdc-data-table__cell">
          <ul>
            @for (agreement of agreements(); track agreement.AgreementNumber) {
              <li>
                <a [routerLink]="['/app/agreements/view', agreement.AgreementNumber]">
                  {{ agreement.AgreementNumber }} - {{ agreement.Title }}
                </a>
              </li>
            }
          </ul>
        </td>
      </tr>
    }
  </tbody>
</table>
